import React from 'react'
import Footer from '../components/Footer/Footer'
import Navbar from '../components/Navbar/Navbar'
import Service from '../components/Service/Service'

const Servicepage = () => {
    return (
        <div>
        <Navbar/>
        <Service/>


        <Footer/>

        </div>
    )
}

export default Servicepage